import { ComponentPropsWithoutRef } from "react";

import Button from "@/components/Button";
import { cn } from "@/utils/cn";

interface TableFilterButton extends ComponentPropsWithoutRef<"button"> {
  isActive?: boolean;
  isNew?: boolean;
}

const TableFilterButton = ({
  children,
  isActive = false,
  className,
  isNew = false,
  ...props
}: TableFilterButton) => {
  return (
    <Button
      variant="custom"
      className={cn(
        "relative break-keep rounded-full border px-3 py-1 text-small transition-colors",
        isActive
          ? "border-primary bg-primary font-medium text-white"
          : "border-gray-200 bg-white text-gray-600 hover:border-primary/50 hover:text-primary",
        className,
      )}
      {...props}
    >
      {children}
      {isNew && (
        <div className="absolute -right-2 -top-2 z-10 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-white">
          N
        </div>
      )}
    </Button>
  );
};

export default TableFilterButton;
